import { inject, Injectable } from '@angular/core';

import { KeycloakProfile } from 'keycloak-js';
import { MessageService } from './message.service';

export const PROFILE_KEY = 'ang-profile';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private readonly keycloak = (window as any).keycloak;
  private messageService = inject(MessageService);

  profile: KeycloakProfile;
  token: string;

  constructor() {
    // Keycloak SSO check on service construction
    if (this.keycloak && !this.keycloak.initialized) {
      this.keycloak.init({ onLoad: 'check-sso' }).success((auth: boolean) => {
        if (auth) {
          this.loadProfile();
        }
      });
      this.keycloak.initialized = true;
    }

    if (!localStorage[PROFILE_KEY]) {
      console.warn('No profile found in localStorage');
      return;
    }
    this.profile = JSON.parse(localStorage[PROFILE_KEY]);
    this.token = JSON.parse(localStorage[PROFILE_KEY]).attributes.token;
  }

  getEmail(): string {
    return this.profile.email;
  }
  getFirstName(): string {
    return this.profile.firstName;
  }
  getLastName(): string {
    return this.profile.lastName;
  }
  getToken(): string {
    return this.token;
  }
  getUsername(): string {
    return this.profile.username;
  }
  isAuthenticated(): boolean {
    console.debug(`Checking authentication status, profile loaded: ${!!this.profile}`);
    return !!this.profile;
  }
  loadProfile() {
    this.keycloak.loadUserProfile().success((profile) => {
      this.profile = profile;
      localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
      localStorage.setItem('ang-token', this.keycloak.token);
      localStorage.setItem('ang-refresh-token', this.keycloak.refreshToken);

      setTimeout(() => {
        this.keycloak.updateToken(70).success((refreshed) => {
          if (refreshed) {
                       console.debug('Token refreshed' + refreshed);
          } else {
            console.warn('Token not refreshed, valid for '
              + Math.round(this.keycloak.tokenParsed.exp + this.keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
          }
        }).error(() => {
          console.error('Failed to refresh token');
        });
      }, 60000);

      this.messageService.set(`Welcome back, ${this.getFirstName()}!`);

      window.dispatchEvent(new Event('profile:loaded'));
    }).error(() => {
      alert('Failed to load user profile');
    });
  }
  login() {
    console.log('Logging in with Keycloak');
    this.keycloak.login({ redirectUri: window.location.origin + '/dashboard' }).success((auth: boolean) => {
      if (auth) {
        console.log('Authenticated');
        this.loadProfile();
      } else {
        console.error('Authenticated Failed');
        this.messageService.set(`Authentication failed, please try again or contact support.`);
      }
    }).error(() => {
      console.error('Authenticated Failed');
      this.messageService.set(`Authentication failed, please try again or contact support.`);
    });
  }
  logout() {
    console.log('Logging out from Keycloak');
    this.keycloak.logout({ redirectUri: window.location.origin + '/dashboard' });
  }
}
